import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import { useSearchParams, useLocation } from "react-router-dom";
import { dispatch } from "../../store";
import { getThemeColor } from "../../utils/constants";
import CartMenu from "./CartMenu";

/**
 *
 * @param {string} path
 */
const showCartButton = (path, slug) => {
  return (
    !path.includes(`/${slug}/checkout`) && !path.includes(`/${slug}/success`)
  );
};

export default function Header({ store, theme }) {
  const [showSearchPopup, setSearchPopup] = useState(false);
  const Navigate = useNavigate();
  const [showCart, setShowCart] = useState(false);
  const [searchInput, setSearchInput] = useState({
    text: "",
    category: 0,
  });
  const cart = useSelector((state) => state.cart);
  const location = useLocation();
  const { slug } = useParams();

  return (
    <>
      <div id="header" className="header">
        <div className="header-main">
          <header className="header-wrap position-relative container d-flex align-items-center mb-2">
            <div className="row g-0 align-items-center w-100">
              <div className="col-4 col-sm-4 col-md-4 col-lg-5 d-none d-lg-block">
                <ul className="social-icons list-inline">
                  {store?.facebookLink && (
                    <li className="list-inline-item">
                      <a
                        href={store?.facebookLink}
                        target="_blank"
                        rel="noopener noreferrer">
                        <i
                          className="an an-facebook"
                          aria-hidden="true"
                          style={{
                            color: getThemeColor(theme).backgroundColor,
                          }}></i>
                        <span className="tooltip-label">Facebook</span>
                      </a>
                    </li>
                  )}
                  {store?.twitterLink && (
                    <li className="list-inline-item">
                      <a
                        href={store?.twitterLink}
                        target="_blank"
                        rel="noopener noreferrer">
                        <i
                          className="an an-twitter"
                          aria-hidden="true"
                          style={{
                            color: getThemeColor(theme).backgroundColor,
                          }}></i>
                        <span className="tooltip-label">Twitter</span>
                      </a>
                    </li>
                  )}

                  {store?.instagramLink && (
                    <li className="list-inline-item">
                      <a
                        href={store?.instagramLink}
                        target="_blank"
                        rel="noopener noreferrer">
                        <i
                          className="an an-instagram"
                          aria-hidden="true"
                          style={{
                            color: getThemeColor(theme).backgroundColor,
                          }}></i>
                        <span className="tooltip-label">Instagram</span>
                      </a>
                    </li>
                  )}
                  {store?.tiktokLink && (
                    <li className="list-inline-item">
                      <a
                        href={store?.tiktokLink}
                        target="_blank"
                        rel="noopener noreferrer">
                        <i
                          className="an an-tiktok"
                          aria-hidden="true"
                          style={{
                            color: getThemeColor(theme).backgroundColor,
                          }}></i>
                        <span className="tooltip-label">TikTok</span>
                      </a>
                    </li>
                  )}
                  {store?.whatsappLink && (
                    <li className="list-inline-item">
                      <a
                        href={store?.whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer">
                        <i
                          className="an an-whatsapp"
                          aria-hidden="true"
                          style={{
                            color: getThemeColor(theme).backgroundColor,
                          }}></i>
                        <span className="tooltip-label">Whatsapp</span>
                      </a>
                    </li>
                  )}
                </ul>
              </div>

              <div className="col-6 col-sm-6 col-md-6 col-lg-2 d-flex">
                {/* <button
                  type="button"
                  onClick={() => setOpenNav(true)}
                  className="btn--link site-header__menu js-mobile-nav-toggle mobile-nav--open me-3 d-lg-none">
                  <i className="icon an an-times-l"></i>
                  <i className="icon an an-bars-l"></i>
                </button> */}

                <div className="logo mx-lg-auto d-flex flex-column">
                  <Link to={`/${slug}`}>
                    {store?.logo ? (
                      <img
                        className="logo-img"
                        src={store?.logo}
                        alt={store?.storeName}
                        title="Site Logo"
                      />
                    ) : (
                      <h3 className="mb-0">{store?.storeName}</h3>
                    )}
                  </Link>
                </div>
              </div>

              <div className="col-6 col-sm-6 col-md-6 col-lg-5 icons-col text-right d-flex justify-content-end">
                <div
                  className="site-search iconset"
                  onClick={() => setSearchPopup(true)}>
                  <i
                    className="icon an an-search-l"
                    style={{ color: getThemeColor(theme).backgroundColor }}></i>
                  <span className="tooltip-label">Search</span>
                </div>

                {showCartButton(location.pathname, slug) && (
                  <div
                    className="header-cart iconset"
                    onClick={() => setShowCart(true)}>
                    <span className="site-header__cart btn-minicart">
                      <i
                        className="icon an an-sq-bag"
                        style={{
                          color: getThemeColor(theme).backgroundColor,
                        }}></i>
                      {Object.values(cart).length > 0 && (
                        <span className="site-cart-count counter d-flex-center justify-content-center position-absolute translate-middle rounded-circle">
                          {Object.values(cart).length}
                        </span>
                      )}
                      <span className="tooltip-label">Cart</span>
                    </span>
                  </div>
                )}
              </div>
            </div>
          </header>
          <p className="position-absolute bottom-0 text-center d-none mb-0 d-lg-block nowrap slogan ">
            {store?.slogan}
          </p>

          <div
            id="search-popup"
            style={{
              position: "sticky",
              top: 0,
              display: showSearchPopup ? "block" : "none",
            }}
            className={`search-drawer ${
              showSearchPopup && "active search-active"
            }`}>
            <div className="container">
              <span
                className="closeSearch an an-times-l"
                onClick={() => {
                  setSearchPopup(false);
                }}></span>
              <form
                className="form minisearch"
                id="header-search"
                onSubmit={(e) => {
                  e.preventDefault();
                  setSearchPopup(false);

                  Navigate(
                    `/${slug}?s=${searchInput.text}&category=${searchInput.category}`
                  );
                }}>
                <label className="label">
                  <span>Search</span>
                </label>
                <div className="control">
                  <div className="searchField">
                    <div className="search-category">
                      <select
                        id="rgsearch-category"
                        name="rgsearch[category]"
                        onChange={(e) =>
                          setSearchInput((prev) => ({
                            ...prev,
                            category: e.target.value,
                          }))
                        }
                        data-default="All Categories">
                        <option
                          value={0}
                          label="All Categories"
                          selected="selected">
                          All Categories
                        </option>
                        <optgroup id="rgsearch-shop" label="Shop">
                          {store?.categories.map((category) => (
                            <option
                              key={category.categoryId}
                              value={category.categoryId}>
                              {category.categoryName}
                            </option>
                          ))}
                        </optgroup>
                      </select>
                    </div>
                    <div className="input-box">
                      <button
                        type="submit"
                        title="Search"
                        className="action search"
                        disabled="">
                        <i className="icon an an-search-l"></i>
                      </button>
                      <input
                        type="text"
                        name="q"
                        value={searchInput.text}
                        onChange={(e) =>
                          setSearchInput((prev) => ({
                            ...prev,
                            text: e.target.value,
                          }))
                        }
                        placeholder="Search by keyword or #"
                        className="input-text"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <CartMenu visible={showCart} setVisible={setShowCart} theme={theme} />
      <div
        className="modalOverly"
        style={{
          zIndex: showSearchPopup ? 45 : 666,
          display: showSearchPopup ? "block" : "none",
        }}></div>
    </>
  );
}
